<style scoped>
.loader {
    width: 100%;
    height: calc(100vh - 140px);
    display: flex !important;
    justify-content: center;
    align-items: center;
}
</style>

<template>
    <div class="loader">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>
</template>

<script>
export default {};
</script>
